import { useHistory } from 'react-router-dom'
import React, { useCallback, useState } from 'react'
import { PARTNER_IDENTIFIER } from '../../services/partners'
import { displayModal } from '../../storage/emitter'
import { AnimatePresence, motion } from 'framer-motion'
import { fade } from '../../storage/motionAnimations'
import { Skeleton } from '@mui/material'
import {
  getAssetDuration,
  getAssetGenres, getAssetMinAge,
  getAssetTitle,
  getAssetYear,
} from '../../services/asset'
import { GreyButton, GreyOutlinedButton } from '../Buttons'
import { FavoriteBorder } from '@mui/icons-material'
import videocietyWatermark from 'assets/images/videociety-watermark.png';

export const VCHeroSlide = ({ asset }) => {
  const history = useHistory();
  const [imgLoaded, setImgLoaded] = useState(false);

  const image = asset.images?.screen;

  const onMoreInfoClick = useCallback(() => {
    history.push(`/asset/${PARTNER_IDENTIFIER.VIDEOCIETY}/${asset.id}`);
  }, [asset]);

  const onFavoriteClick = useCallback(() => {
    displayModal("demo");
  }, [asset]);

  const onImageLoad = useCallback(() => {
    setImgLoaded(true);
  }, [image]);

  return (
    <>
      <div className="slide-background">
        <img
          className="slide-image"
          src={image}
          onLoad={onImageLoad}
          alt="Asset Cover"
        />
        <AnimatePresence>
          {!imgLoaded && (
            <motion.div
              variants={fade}
              initial="visible"
              animate="visible"
              exit="exit"
            >
              <Skeleton
                className="slide-image-skelly"
                animation="wave"
                variant="rectangular"
              />
            </motion.div>
          )}
        </AnimatePresence>
        <div className="slide-overlay" />
      </div>
      <div className="asset-content" data-assetid={asset.id}>
        <div className="asset-watermark"><img src={videocietyWatermark} alt="VideoCiety Watermark"/></div>
        <h1 className="asset-title">{getAssetTitle(asset)}</h1>
        <div className="asset-info">
          <div className="asset-genres">{getAssetGenres(asset).join(", ")}</div>
          <div className="info-divider" />
          <div className="asset-year">{getAssetYear(asset)}</div>
          <div className="asset-duration">{getAssetDuration(asset)} Min</div>
          <div className="asset-age">{getAssetMinAge(asset)}</div>
        </div>
        <div className="buttons">
          <GreyButton
            onClick={onMoreInfoClick}
            color="secondary"
            variant="contained"
            className="button button--big"
          >
            More Info
          </GreyButton>
          <GreyOutlinedButton
            onClick={onFavoriteClick}
            color="secondary"
            variant="outlined"
            className="button button--big"
            startIcon={<FavoriteBorder />}
          >
            My List
          </GreyOutlinedButton>
        </div>
      </div>
    </>
  );
};
